import RectangleBlock from "../block/RectangleBlock.jsx";
import { RigidBody, CuboidCollider } from "@react-three/rapier";
import { Line } from "@react-three/drei";
import { Text } from "@react-three/drei";
import { useGame } from "../../../stores/useGame.js";
import { COLORS } from "../../../constants/colors";
import { useEffect } from "react";
import confetti from "canvas-confetti";

const RaceFinish = ({ position = [0, 0, 0], rotation = [0, 0, 0] }) => {
  const endTime = useGame((state) => state.endTime);
  const startTime = useGame((state) => state.startTime);
  const startRace = useGame((state) => state.startRace);
  const bestTimes = useGame((state) => state.bestTimes);
  const showFireworks = useGame((state) => state.showFireworks);
  const stopFireworks = useGame((state) => state.stopFireworks);
  const { setFinishButtonActive, end } = useGame();

  const elapsedTime = ((endTime - startTime) / 1000).toFixed(2);

  // Запускаем фейерверки при пересечении финиша
  useEffect(() => {
    if (showFireworks) {
      // Основной взрыв в центре
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
      });

      // Дополнительные взрывы с задержкой
      setTimeout(() => {
        confetti({
          particleCount: 50,
          angle: 60,
          spread: 55,
          origin: { x: 0.2, y: 0.6 },
        });
      }, 250);

      setTimeout(() => {
        confetti({
          particleCount: 50,
          angle: 120,
          spread: 55,
          origin: { x: 0.8, y: 0.6 },
        });
      }, 500);

      // Останавливаем фейерверки через 3 секунды
      const timer = setTimeout(() => {
        stopFireworks();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showFireworks, stopFireworks]);

  // Точки для белой финишной линии

  const SIZE = 2.9;
  const WIDTH = 0.2;
  const finishLinePoints = [
    [-SIZE, 0, -WIDTH],
    [SIZE, 0, -WIDTH],
    [SIZE, 0, WIDTH / 4],
    [-SIZE, 0, WIDTH / 4],
    [-SIZE, 0, -WIDTH],
  ];

  return (
    <group position={position} rotation={rotation}>
      <RigidBody type="fixed" friction={1} restitution={0} ccd={false}>
        <mesh>
          <boxGeometry args={[6, 0.01, 6]} />
          <meshStandardMaterial color={COLORS.surfaceElements} />
        </mesh>
      </RigidBody>

      {/* Sensor коллайдер для определения финиша */}
      <RigidBody
        type="fixed"
        sensor={true}
        ccd={false}
        userData={{ isFinishButton: true }}
        position-y={0.5}
        position-z={2.6}
        onIntersectionEnter={(other) => {
          if (other.rigidBodyObject?.userData?.isCar) {
            setFinishButtonActive(true);

            // Автоматически завершаем гонку при пересечении финиша
            if (startRace) {
              end();
            }
          }
        }}
        onIntersectionExit={(other) => {
          if (other.rigidBodyObject?.userData?.isCar) {
            setFinishButtonActive(false);
          }
        }}
      >
        <CuboidCollider args={[3, 0.05, 0.2]} />
      </RigidBody>

      {/* Белая финишная линия */}
      <Line
        points={finishLinePoints}
        color={COLORS.kubes}
        dashed={false}
        lineWidth={10}
        position={[0, 0.03, SIZE]}
      />

      <RectangleBlock position={[2.8, 0.6, 0]} />
      <RectangleBlock position={[-2.8, 0.6, 0]} />
      <Text
        scale={0.8}
        rotation-x={-Math.PI / 2}
        rotation-z={Math.PI}
        position={[7, 0.1, 2]}
      >
        Your top 3:
      </Text>
      {[0, 1, 2].map((index) => (
        <Text
          key={index}
          scale={0.7}
          rotation-x={-Math.PI / 2}
          rotation-z={Math.PI}
          position={[7, 0.1, 1.5 - (index + 1) * 1]}
          textAlign="left"
        >
          {index + 1}.{" "}
          {bestTimes && bestTimes[index]
            ? `${bestTimes[index].toFixed(2)}s`
            : "-"}
        </Text>
      ))}

      {!startRace && (
        <>
          {/* Текущее время */}
          <Text
            scale={1}
            rotation-x={-Math.PI / 2}
            rotation-z={Math.PI}
            position={[0, 0.1, 4]}
          >
            {elapsedTime}
          </Text>
        </>
      )}
    </group>
  );
};

export default RaceFinish;
